import { Bar, BarChart as RBarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import Box from "@mui/material/Box";
import { SERIES_COLORS } from "./palette";

export type BarDatum = { label: string; value: number };
export type BarChartProps = {
  data: BarDatum[];
  ariaLabel: string;
  height?: number;
  width?: number;
  horizontal?: boolean;
  valueFormatter?: (v: number) => string;
  /** Cor por barra (histograma colorido do "pedido → dinheiro"). */
  colorFor?: (d: BarDatum, index: number) => string;
};

export const formatBarValue = (v: number, valueFormatter?: (v: number) => string) => (valueFormatter ? valueFormatter(v) : v);

// width fixo = sem ResponsiveContainer (que mede 0 no jsdom); sem width = ocupa 100% do pai.
export default function BarChart({ data, ariaLabel, height = 240, width, horizontal = false, valueFormatter, colorFor }: BarChartProps) {
  const chart = (
    <RBarChart data={data} layout={horizontal ? "vertical" : "horizontal"} width={width} height={height}>
      <CartesianGrid strokeDasharray="3 3" vertical={false} />
      {horizontal ? <YAxis type="category" dataKey="label" width={180} /> : <XAxis dataKey="label" />}
      {horizontal ? <XAxis type="number" /> : <YAxis />}
      <Tooltip formatter={(v: number) => formatBarValue(v, valueFormatter)} />
      <Bar dataKey="value" fill={SERIES_COLORS[0]} isAnimationActive={false}>
        {colorFor && data.map((d, i) => <Cell key={`${d.label}-${i}`} fill={colorFor(d, i)} />)}
      </Bar>
    </RBarChart>
  );
  return (
    <Box role="img" aria-label={ariaLabel}>
      {width ? chart : <ResponsiveContainer width="100%" height={height}>{chart}</ResponsiveContainer>}
    </Box>
  );
}
